import Utils from '@/utils'

export default defineNuxtPlugin((nuxtApp) => {
  const layoutStore = useLayoutStore()
  const locationStore = useLocationStore()
  const bookingStore = useBookingStore()
  const authStore = useAuthStore()
  const giftStore = useGiftStore()
  const passStore = usePassStore()

  const stores = {
    location: locationStore,
    booking: bookingStore,
    auth: authStore,
    gift: giftStore,
    pass: passStore,
  }

  const store = {
    getters: new Proxy({}, {
      get (target, prop: string) {
        let [storeName, getterName] = prop.split('/')

        if (!getterName) {
          return layoutStore[storeName]
        }
        
        return stores[storeName]?.[getterName]
      }
    }),
    dispatch: async function (prop: string, ...args: any) {
      let [storeName, actionName] = prop.split('/')

      if (!actionName) {
        return await layoutStore[storeName](...args)
      }

      return await stores[storeName]?.[actionName](...args)
    },
  }

  nuxtApp.provide('store', store)
})
